export default __webpack_public_path__ + "static/media/newsimplan-icon03-tc.caf9b613.png";